import React, { Suspense } from "react";
import { useSelector } from "react-redux";
import AppRoutes from "./Routes/AppRoutes";

const ChatbotComponent = React.lazy(() => import("./supportBot/ChatbotComponent"));

export default function App() {
  const user = useSelector((s) => s.auth?.userID);

  return (
    <div className="w-full min-h-[100dvh] relative overflow-auto">
      {/* Background Image */}
      <img
        src="/ZynexAI_BG_Image.webp"
        alt="background"
        width="1920"
        height="1080"
        className="fixed inset-0 w-full h-full object-cover -z-10"
        loading="eager"
        fetchpriority="high"
        decoding="async"
      />

      <div className="relative z-10">
        <AppRoutes />
      </div>

      <Suspense fallback={null}>
        <ChatbotComponent user={user} />
      </Suspense>
    </div>
  );
}